
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { CalendarConnection } from "@/types/calendar";
import { useEffect } from "react";

interface CalendarDisconnectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  connection: CalendarConnection | null;
  onConfirmDisconnect: () => void;
}

const getProviderDisplayName = (provider: string) => {
  switch (provider) {
    case 'google':
      return 'Google Calendar';
    case 'outlook':
      return 'Outlook Calendar';
    default:
      return 'Calendar';
  }
};

const CalendarDisconnectDialog = ({ 
  open, 
  onOpenChange, 
  connection, 
  onConfirmDisconnect 
}: CalendarDisconnectDialogProps) => {
  // Handle cleanup when dialog closes
  useEffect(() => {
    if (!open) {
      // Ensure focus is properly managed when dialog closes
      setTimeout(() => {
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement && activeElement.blur) {
          activeElement.blur();
        }
        // Focus the document body to ensure proper focus state
        document.body.focus();
      }, 100);
    }
  }, [open]);

  const handleConfirmDisconnect = () => {
    onConfirmDisconnect();
    // Immediately close the dialog to prevent focus issues
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Disconnect {connection ? getProviderDisplayName(connection.provider) : 'Calendar'}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This will disconnect this calendar from Shared Matter. Your events and reminders will no longer sync.
            Are you sure you want to continue?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirmDisconnect}
            className="bg-red-600 hover:bg-red-700"
          >
            Yes, Disconnect
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CalendarDisconnectDialog;
